import { render, staticRenderFns } from "./SurveyUsersAnswersList.vue?vue&type=template&id=639ee938&scoped=true&"
import script from "./SurveyUsersAnswersList.vue?vue&type=script&lang=ts&"
export * from "./SurveyUsersAnswersList.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyUsersAnswersList.vue?vue&type=style&index=0&id=639ee938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639ee938",
  null
  
)

export default component.exports